











import { Component, Vue } from "vue-property-decorator";
import { LayoutModule } from "@/store/layout";
import AdUnitForm from "./Components/AdUnitForm.vue";
import AdUnit from "@/models/adUnit";
import AdUnitsAPI from "@/services/adUnits";

@Component({
  components: { AdUnitForm },
})
export default class EditAdUnit extends Vue {
  model: AdUnit = new AdUnit();
  loading = true;

  created(): void {
    if (this.$route.params.id) this.getRecord();
  }

  async getRecord(): Promise<void> {
    try {
      const data = await AdUnitsAPI.get(this.$route.params.id);
      this.model = new AdUnit(data);
    } catch (e) {
      console.log(e);
    } finally {
      this.loading = false;
    }
  }

  async save(model: AdUnit): Promise<void> {
    LayoutModule.showLoader();
    try {
      await AdUnitsAPI.update(model);
      LayoutModule.setAlerts({
        text: this.$t("ad_units.responses.success_update").toString(),
        type: "success",
      });
    } catch (e) {
      console.log(e);
    }
    LayoutModule.hideLoader();
  }

  cancel(): void {
    this.$router.push({ name: "ad_units" });
  }
}
